import { AuthEffects } from './app/auth.effects';
import { CountriesEffects } from './country/countries.effects';
import { ScreensEffects } from './screen/screen.effects';

export const EffectsArray: any[] = [
    AuthEffects,
    CountriesEffects,
    ScreensEffects
];
